import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const FilterIcon = ({ size = 14, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 6h16M7 12h10M10 18h4" />
  </svg>
)
